var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'text-muted': !_vm.hasValue },domProps:{"innerHTML":_vm.displayValue}})}
var staticRenderFns = []

export { render, staticRenderFns }